// src/primate/api/oauth.ts — OAuth consent flow (PRI-462)
//
// Website side of the OAuth 2.1 authorization flow for the hosted MCP
// endpoint. The API's GET /oauth/authorize redirects the user's browser to
// {WEB_ORIGIN}/oauth/consent?request_id={id}; the consent page uses these
// helpers (Clerk JWT auth via the shared token registry) to fetch the pending
// request, then approve or deny it.

import { request } from '../../core/lib/api/client'

export interface ConsentApiKey {
  id: string
  label: string
  last4: string
}

export interface ConsentRequest {
  request_id: string
  client_name: string
  scope: string
  api_keys: ConsentApiKey[]
}

export interface ConsentRedirect {
  redirect_to: string
}

/** GET /oauth/consent-request/:id — pending authorization request details. */
export async function getConsentRequest(id: string): Promise<ConsentRequest> {
  return request<ConsentRequest>(`/oauth/consent-request/${encodeURIComponent(id)}`)
}

/** POST /oauth/consent-request/:id/approve — mint the single-use auth code. */
export async function approveConsentRequest(id: string, apiKeyId: string): Promise<ConsentRedirect> {
  return request<ConsentRedirect>(`/oauth/consent-request/${encodeURIComponent(id)}/approve`, {
    method: 'POST',
    body: JSON.stringify({ api_key_id: apiKeyId }),
  })
}

/** POST /oauth/consent-request/:id/deny — access_denied redirect back to the client. */
export async function denyConsentRequest(id: string): Promise<ConsentRedirect> {
  return request<ConsentRedirect>(`/oauth/consent-request/${encodeURIComponent(id)}/deny`, {
    method: 'POST',
  })
}
